import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './LoginPage.css';

export function ForgotPasswordPage() {
    const { requestPasswordReset } = useAuth();
    const params = new URLSearchParams(window.location.search);
    const [email, setEmail] = useState('');
    const [error, setError] = useState(() => {
        const recoveryError = params.get('recoveryError');
        return recoveryError ? decodeURIComponent(recoveryError) : '';
    });
    const [loading, setLoading] = useState(false);
    const [submittedEmail, setSubmittedEmail] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        const trimmedEmail = email.trim();
        if (!trimmedEmail) return;

        setLoading(true);
        setError('');

        const requestError = await requestPasswordReset(trimmedEmail);
        if (requestError) {
            setError(requestError);
            setLoading(false);
            return;
        }

        setSubmittedEmail(trimmedEmail);
        setLoading(false);
    };

    return (
        <section className="login-page-wrap">
            <div className="login-card">
                <div className="login-brand-row">
                    <div className="login-brand-mark" aria-hidden="true">R</div>
                    <h1 className="login-brand-title">regattamanager</h1>
                </div>

                <p className="login-subtitle">Reset your password</p>

                {error && <div className="alert alert-danger login-alert">{error}</div>}

                {submittedEmail ? (
                    <>
                        <div className="alert alert-success login-alert mb-3">
                            If an account exists for <strong>{submittedEmail}</strong>, we&apos;ve sent a password reset link.
                        </div>
                        <p className="login-secondary-note">
                            Opening that email link re-validates the address before we let you choose a new password.
                        </p>
                        <p className="login-footer-note">
                            <Link to="/login">Back to sign in</Link>
                        </p>
                    </>
                ) : (
                    <>
                        <p className="login-secondary-note">
                            Enter your email and we&apos;ll send you a one-time recovery link.
                        </p>

                        <form onSubmit={handleSubmit} className="login-form">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="forgot-password-email">Email</label>
                                <input
                                    id="forgot-password-email"
                                    type="email"
                                    className="form-control"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    autoComplete="email"
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary w-100 login-submit-btn" disabled={loading}>
                                {loading ? 'Sending reset link...' : 'Send reset link'}
                            </button>
                        </form>

                        <p className="login-footer-note">
                            Remembered it? <Link to="/login">Back to sign in</Link>
                        </p>
                    </>
                )}
            </div>
        </section>
    );
}